import { render } from "./coursevideos.vue?vue&type=template&id=3d45cda5&scoped=true"
import script from "./coursevideos.vue?vue&type=script&lang=js"
export * from "./coursevideos.vue?vue&type=script&lang=js"

import "./coursevideos.vue?vue&type=style&index=0&id=3d45cda5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d45cda5"]])

export default __exports__